{
  "title": "Heroes' Feast",
  "source": "Player's Handbook",
  "levelAndSchool": "6th-level conjuration",
  "level": 6,
  "castingTime": "10 minutes",
  "range": "30 feet",
  "components": "V, S, M (a gem-encrusted bowl worth at least 1,000 gp, which the spell consumes)",
  "duration": "Instantaneous",
  "description": [
    "You bring forth a great feast, including magnificent food and drink. The feast takes 1 hour to consume and disappears at the end of that time, and the beneficial effects don’t set in until this hour is over. Up to twelve creatures can partake of the feast.",
    "A creature that partakes of the feast gains several benefits. The creature is cured of all diseases and poison, becomes immune to poison and being frightened, and makes all Wisdom saving throws with advantage. Its hit point maximum also increases by 2d10, and it gains the same number of hit points. These benefits last for 24 hours."
  ],
  "spellLists": ["bard", "cleric", "druid"]
}
